import { css } from '@emotion/react';

import { createSlickSettings } from '~/src/components/carousels/BaseCarousel/createSlickSettings';
import { breakpoints, fontWeight } from '~/src/styles';
import { typography } from '~/src/styles/design-system';

const desktopSettings = {
  dots: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  // NOTE it's make sense to 'progressive' it only if you need to see cards beyond the borders
  lazyLoad: 'progressive' as const,
};

export const spaceBetweenCards = 16;

const slickSettings = createSlickSettings({
  sm: {
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  },
  md: {
    dots: false,
    slidesToShow: 2,
    slidesToScroll: 1,
  },
  lg: { ...desktopSettings, slidesToShow: 2 },
  xl: desktopSettings,
  xxl: desktopSettings,
});
export const carouselSettings = {
  paddingTop: '0',
  paddingBottom: '0',
  button: null,
  deprecatedEnableCarouselInvisibleCard: false,
  headerCSS: css({
    marginBottom: 'var(--Heading-Padding)',
    span: css(typography.bodyText, {
      fontWeight: fontWeight.semiBold,
      color: 'var(--Dark-Text, #27292D)',
      textTransform: 'capitalize',
      margin: 0,
      [breakpoints.minTablet]: {
        fontWeight: fontWeight.bold,
        color: 'var(--Dark-Text, #27292D)',
      },
      [breakpoints.minDesktop]: {
        color: 'var(--Dark-Text, #27292D)',
        fontSize: '32px',
        fontWeight: fontWeight.semiBold,
        lineHeight: '40px',
        letterSpacing: '1.6px',
      },
    }),
  }),
  containerStyles: { padding: 0 },
  slickSettings,
  overrideSlickCarouselCSS: css({
    '.slick-list': {
      padding: '0',
      marginTop: '0px !important',
    },
    '.slick-slide': { paddingLeft: 0, paddingRight: `${spaceBetweenCards}px` },
    '.slick-slide>div:first-of-type': { marginBottom: 0 },
    '.slick-arrow': {
      border: '1px solid #E9E9E9',
    },
    '.play-btn': {
      display: 'none',
    },
  }),
};
